import {
    GET_THIRD_PARTY_ORDERS,
    THIRD_PARTY_ORDERS_ERROR,
    THIRD_PARTY_ORDERS_EXPORT_LOADING,
    THIRD_PARTY_ORDERS_EXPORT_SUCCESS,
    THIRD_PARTY_ORDERS_LOADING,
} from "../actions/types";

const initialState = {
  orders: [],
  meta: { total: 0 },
  loading: false,
  exportLoading: false,
  error: null,
};

export default function thirdPartyOrdersReducer(state = initialState, action) {
  switch (action.type) {
    case THIRD_PARTY_ORDERS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_THIRD_PARTY_ORDERS:
      return {
        ...state,
        orders: action.payload.orders || [],
        meta: action.payload.meta || { total: 0 },
        loading: false,
        error: null,
      };
    case THIRD_PARTY_ORDERS_ERROR:
      return {
        ...state,
        loading: false,
        exportLoading: false,
        error: action.payload,
      };
    case THIRD_PARTY_ORDERS_EXPORT_LOADING:
      return {
        ...state,
        exportLoading: true,
        error: null,
      };
    case THIRD_PARTY_ORDERS_EXPORT_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        error: null,
      };
    default:
      return state;
  }
}
